import { useCampaignSlug } from '@/lib/useCampaignSlug'

export const useLocalStorageClear = () => {
  const {
    LOCAL_STORAGE_PERIOD_KEY,
    LOCAL_STORAGE_USERNAME_KEY,
    LOCAL_STORAGE_REFRESH_KEY,
    LOCAL_STORAGE_JWT_KEY,
    LOCAL_STORAGE_CLIENT_ID_KEY,
    LOCAL_STORAGE_REGISTER_QUESTIONNAIRES_KEY,
  } = useCampaignSlug()
  return () => {
    localStorage.removeItem(LOCAL_STORAGE_PERIOD_KEY)
    localStorage.removeItem(LOCAL_STORAGE_USERNAME_KEY)
    localStorage.removeItem(LOCAL_STORAGE_CLIENT_ID_KEY)
    localStorage.removeItem(LOCAL_STORAGE_REGISTER_QUESTIONNAIRES_KEY)
    localStorage.removeItem(LOCAL_STORAGE_REFRESH_KEY)
    localStorage.removeItem(LOCAL_STORAGE_JWT_KEY)
  }
}
